export default function Marquee() {
  const items = [
    "PAN BIMBO",
    "COCA COLA",
    "AZÚCAR",
    "FRIJOL",
    "CORONA",
    "CUADERNO PROFESIONAL",
    "SABRITAS",
    "GANSITO",
    "MASECA",
    "TORTILLAS",
    "TAKIS",
    "DEL VALLE",
  ];
  const row = [...items, ...items];

  return (
    <section
      className="relative py-16 md:py-24 border-y border-white/10 overflow-hidden bg-[#080808]"
      data-testid="marquee"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 mb-8 flex items-center justify-between">
        <p className="font-mono text-[11px] tracking-[0.3em] text-white/40 uppercase">
          / Lo que CHALANN escucha todos los días
        </p>
        <p className="font-mono text-[11px] tracking-[0.3em] text-white/40 uppercase">
          / 12,000+ productos reconocidos
        </p>
      </div>

      <div className="relative">
        <div className="marquee-track">
          {row.map((word, i) => (
            <span
              key={i}
              className="font-display text-[10vw] md:text-[8vw] leading-none tracking-tighter px-8 flex items-center"
              style={{
                color: i % 3 === 0 ? "#ff5a00" : i % 5 === 0 ? "#ccff00" : "#f5f5f5",
                WebkitTextStroke: i % 4 === 0 ? "1px #f5f5f5" : undefined,
                WebkitTextFillColor: i % 4 === 0 ? "transparent" : undefined,
              }}
            >
              {word}
              <span className="mx-6 text-white/20">·</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
